import { useEffect, useState } from "react";
import { useFormik } from "formik";
import axios from "axios";
import { ButtonLoader4 } from "../../components/ButtonLoader";
import * as Yup from "yup";
import { getAccessToken } from "../../storage/storage";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PlaceAutocomplete from "../../components/shared/PlaceAutocomplete";

const ContactFormSchema = Yup.object({
  address_line1: Yup.string().required("Enter address_line1"),
  city: Yup.string().required("Enter city"),
  country: Yup.string().required("Enter country"),
  postal_code: Yup.string().required("Enter zip code"),
    mobile_number: Yup.string()
    .required("Enter mobile number")
    .matches(/^\+?[0-9]{10,15}$/, "Enter a valid mobile number (10-15 digits, optional +)"),
  no_of_properties: Yup.string().required("Select number of properties"),
  hear_about_us: Yup.string().required("Select an option"),
  use_as: Yup.string().required("Select an option"),
});

const initialValues = {
  address_line1: "",
  address_line2: "",
  city: "",
  country: "",
  postal_code: "",
  name: "",
  company_number: "",
  mobile_number: "",
  no_of_properties: "",
  hear_about_us: "",
  use_as: "",
};

const Home = () => {
  const Navigate = useNavigate();
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const [PMS_OPTIONS, setPMS_OPTIONS] = useState([]);
  const [options, setOptions] = useState([]);
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [sublocality, setSublocality] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/social-types/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setPMS_OPTIONS(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PMS options:", error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/types/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setOptions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
      });
  }, []);

  const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: ContactFormSchema,
      onSubmit: async (values, action) => {
        setLoading(true);
        await axios
          .post(`${BASE_URL}/api/companies/`, values, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            Swal.fire({
              icon: "success",
              title:
                response.data.message || "Data Has Been Added Successfully",
              timer: 2000,
              showConfirmButton: false,
              position: "center",
            });
            sessionStorage.setItem("companyInfo", "true");
            setLoading(false);
            Navigate("/dashboard");
            action.resetForm();
          })
          .catch((error) => {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: error.response?.data?.message || "Something went wrong!",
              timer: 2000,
              showConfirmButton: false,
              position: "center",
            });
          });
      },
    });

  // const handleSelect = (selected) => {
  //   if (!selected) return;
  //   setAddress(selected);

  //   // Google Maps API Call
  //   fetch(
  //     `https://maps.googleapis.com/maps/api/geocode/json?place_id=${selected.value.place_id}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.results.length > 0) {
  //         const addressComponents = data.results[0].address_components;
  //         let cityName = "";
  //         let stateName = "";
  //         let countryName = "";
  //         let postalCodeValue = "";

  //         addressComponents.forEach((component) => {
  //           if (component.types.includes("locality")) {
  //             cityName = component.long_name;
  //           }
  //           if (
  //             component.types.includes("administrative_area_level_2") &&
  //             !cityName
  //           ) {
  //             cityName = component.long_name; // Backup city if locality is missing
  //           }
  //           if (component.types.includes("sublocality") && !cityName) {
  //             cityName = component.long_name; // Another backup
  //           }
  //           if (component.types.includes("administrative_area_level_1")) {
  //             stateName = component.long_name;
  //           }
  //           if (component.types.includes("country")) {
  //             countryName = component.long_name;
  //           }
  //           if (component.types.includes("postal_code")) {
  //             postalCodeValue = component.long_name;
  //           }
  //         });

  //         // **Restrict Non-UK Addresses**
  //         if (countryName !== "United Kingdom") {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Invalid Address",
  //             text: "Only UK addresses are allowed.",
  //           });
  //           return; // Stop execution
  //         }

  //         setCity(cityName);
  //         setCountry(countryName);
  //         setPostalCode(postalCodeValue);

  //         // Update Formik values
  //         setFieldValue("city", cityName);
  //         setFieldValue("state", stateName); // Set state
  //         setFieldValue("country", countryName);
  //         setFieldValue("postal_code", postalCodeValue);
  //         setFieldValue("address_line1", data.results[0].formatted_address);
  //       }
  //     })
  //     .catch((error) =>
  //       console.error("Error fetching address details:", error)
  //     );
  // };

  // const handleSelect = (selected) => {
  //   if (!selected) return;
  //   setAddress(selected);

  //   // Google Maps API Call
  //   fetch(
  //     `https://maps.googleapis.com/maps/api/geocode/json?place_id=${selected.value.place_id}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.results.length > 0) {
  //         const addressComponents = data.results[0].address_components;
  //         let cityName = "";
  //         let stateName = "";
  //         let countryName = "";
  //         let postalCodeValue = "";
  //         let sublocalityName = ""; // State to store "Stag Hill" or similar area name

  //         addressComponents.forEach((component) => {
  //           if (component.types.includes("locality")) {
  //             cityName = component.long_name;
  //           }
  //           if (
  //             component.types.includes("administrative_area_level_2") &&
  //             !cityName
  //           ) {
  //             cityName = component.long_name; // Backup city if locality is missing
  //           }
  //           if (component.types.includes("sublocality") && !cityName) {
  //             sublocalityName = component.long_name; // Capture sublocality like "Stag Hill"
  //           }
  //           if (component.types.includes("administrative_area_level_1")) {
  //             stateName = component.long_name;
  //           }
  //           if (component.types.includes("country")) {
  //             countryName = component.long_name;
  //           }
  //           if (component.types.includes("postal_code")) {
  //             postalCodeValue = component.long_name;
  //           }
  //         });

  //         // **Restrict Non-UK Addresses**
  //         if (countryName !== "United Kingdom") {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Invalid Address",
  //             text: "Only UK addresses are allowed.",
  //           });
  //           return; // Stop execution
  //         }

  //         // Set the sublocality value to state (e.g., Stag Hill)
  //         setSublocality(sublocalityName); // New state for "Stag Hill"
  //         setCity(cityName);
  //         setCountry(countryName);
  //         setPostalCode(postalCodeValue);

  //         // Update Formik values
  //         setFieldValue("address_line1", sublocalityName);
  //         setFieldValue("city", cityName);
  //         setFieldValue("state", stateName); // Set state
  //         setFieldValue("country", countryName);
  //         setFieldValue("postal_code", postalCodeValue);
  //         // setFieldValue("address_line1", data.results[0].formatted_address);
  //       }
  //     })
  //     .catch((error) =>
  //       console.error("Error fetching address details:", error)
  //     );
  // };

  // const handleSelect = (selected) => {
  //   if (!selected) return;
  //   setAddress(selected);

  //   // Google Maps API Call
  //   fetch(
  //     `https://maps.googleapis.com/maps/api/geocode/json?place_id=${selected.value.place_id}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.results.length > 0) {
  //         const addressComponents = data.results[0].address_components;
  //         let cityName = "";
  //         let stateName = "";
  //         let countryName = "";
  //         let postalCodeValue = "";
  //         let sublocalityName = ""; // State to store "Stag Hill" or similar area name

  //         addressComponents.forEach((component) => {
  //           if (component.types.includes("locality")) {
  //             cityName = component.long_name;
  //           }
  //           if (
  //             component.types.includes("administrative_area_level_2") &&
  //             !cityName
  //           ) {
  //             cityName = component.long_name; // Backup city if locality is missing
  //           }
  //           if (component.types.includes("sublocality") && !cityName) {
  //             sublocalityName = component.long_name; // Capture sublocality like "Stag Hill"
  //           }
  //           if (component.types.includes("administrative_area_level_1")) {
  //             stateName = component.long_name;
  //           }
  //           if (component.types.includes("country")) {
  //             countryName = component.long_name;
  //           }
  //           if (component.types.includes("postal_code")) {
  //             postalCodeValue = component.long_name;
  //           }
  //         });

  //         // **Restrict Non-UK Addresses**
  //         if (countryName !== "United Kingdom") {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Invalid Address",
  //             text: "Only UK addresses are allowed.",
  //           });
  //           return; // Stop execution
  //         }

  //         // Fallback for sublocality and state
  //         if (!sublocalityName) {
  //           // Use only sublocality, city, or state, but exclude postal code and country
  //           const formattedAddress = data.results[0]?.formatted_address || "";
  //           const filteredAddress = formattedAddress
  //             .split(", ")
  //             .filter((part) => {
  //               return (
  //                 !part.includes(postalCodeValue) && // Ignore postal code
  //                 !part.includes(countryName) // Ignore country name
  //               );
  //             })
  //             .join(", ");

  //           sublocalityName = filteredAddress;
  //         }

  //         if (!stateName) {
  //           stateName = cityName || sublocalityName || "Unknown"; // Ensure state is set, use city or sublocality if necessary
  //         }

  //         // Set the sublocality value to state (e.g., Stag Hill)
  //         setSublocality(sublocalityName); // New state for "Stag Hill"
  //         setCity(cityName);
  //         setCountry(countryName);
  //         setPostalCode(postalCodeValue);

  //         // Update Formik values
  //         setFieldValue("address_line1", sublocalityName);
  //         setFieldValue("city", cityName);
  //         setFieldValue("state", stateName); // Set state
  //         setFieldValue("country", countryName);
  //         setFieldValue("postal_code", postalCodeValue);
  //         // setFieldValue("address_line1", data.results[0].formatted_address);
  //       }
  //     })
  //     .catch((error) =>
  //       console.error("Error fetching address details:", error)
  //     );
  // };

  const handleSelect = (place) => {
    if (!place) return;
    const addressComponents = place.address_components || [];
    let cityName = "";
    let stateName = "";
    let countryName = "";
    let postalCodeValue = "";
    let sublocalityName = "";

    addressComponents.forEach((component) => {
      if (component.types.includes("locality")) {
        cityName = component.long_name;
      }
      if (component.types.includes("postal_town") && !cityName) {
        cityName = component.long_name;
      }
      if (
        component.types.includes("administrative_area_level_2") &&
        !cityName
      ) {
        cityName = component.long_name;
      }
      if (component.types.includes("sublocality") && !cityName) {
        sublocalityName = component.long_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        stateName = component.long_name;
      }
      if (component.types.includes("country")) {
        countryName = component.long_name;
      }
      if (component.types.includes("postal_code")) {
        postalCodeValue = component.long_name;
      }
    });

    if (countryName !== "United Kingdom") {
      Swal.fire({
        icon: "error",
        title: "Invalid Address",
        text: "Only UK addresses are allowed.",
      });
      return;
    }

    if (!sublocalityName) {
      const formattedAddress = place.formatted_address || "";
      sublocalityName = formattedAddress.split(",")[0];
    }
    if (!stateName) {
      stateName = cityName || sublocalityName || "Unknown";
    }

    setSublocality(sublocalityName);
    setCity(cityName);
    setCountry(countryName);
    setPostalCode(postalCodeValue);

    setFieldValue("address_line1", sublocalityName);
    setFieldValue("city", cityName);
    setFieldValue("state", stateName);
    setFieldValue("country", countryName);
    setFieldValue("postal_code", postalCodeValue);
  };

  return (
    <>
      <div className="md:ml-10">
        <img
          src="/images/main-logo.jpg"
          alt="header-img"
          width={150}
          height={100}
          loading="eager"
          className={`transition-opacity duration-500 ease-in `}
        />
      </div>

      <div className="flex flex-col items-center justify-center">
        <img
          className="w-20 pb-3 transition-opacity duration-500 ease-in"
          src="/images/host.png"
          alt="Host"
          width={80}
          height={80}
          loading="eager"
        />
        <h1 className="md:text-3xl text-xl font-bold text-[#586989] mb-4 text-center">
          Host/Property Manager Registration
        </h1>
        <p className="text-gray-600 mb-6 text-center">
          Tell us about your business to get started
        </p>
      </div>
      <div className="max-w-[800px] mx-auto bg-[#FFF5CE] p-6 rounded-lg shadow-lg mb-10">
        <h2 className="text-xl font-bold mb-4">Host Information</h2>
        <div className="flex flex-col gap-2 pb-3">
          <label>Search Address</label>
          <PlaceAutocomplete
            regionCodes={["gb"]}
            placeholder="Enter UK Address"
            onSelect={handleSelect}
          />
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          <div className="flex flex-col gap-2">
            <label>Address Line1*</label>
            <input
              type="text"
              name="address_line1"
              placeholder="Address Line 1*"
              value={sublocality}
              onChange={(e) => {
                handleChange(e);
                setSublocality(e.target.value);
              }}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />

            {errors.address_line1 && touched.address_line1 && (
              <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
                {errors.address_line1 || ""}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label>Address Line2</label>
            <input
              type="text"
              name="address_line2"
              placeholder="Address Line 2"
              value={values.address_line2}
              onChange={handleChange}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
          </div>
          <div className="flex flex-col gap-2">
            <label>City/Town*</label>
            <input
              type="text"
              name="city"
              value={city}
              onChange={(e) => {
                handleChange(e);
                setCity(e.target.value);
              }}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
            {errors.city && touched.city && (
              <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
                {errors.city || ""}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-2 w-full">
            <label>Country*</label>
            <input
              type="text"
              name="country"
              placeholder="Country*"
              value={country}
              onChange={(e) => {
                handleChange(e);
                setCountry(e.target.value);
              }}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
            {errors.country && touched.country && (
              <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
                {errors.country || ""}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label>Post Code*</label>
            <input
              type="text"
              name="postal_code"
              placeholder="Post Code*"
              value={postalCode}
              onChange={(e) => {
                handleChange(e);
                setPostalCode(e.target.value);
              }}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
            {errors.postal_code && touched.postal_code && (
              <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
                {errors.postal_code || ""}
              </p>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <label>Company Name</label>
            <input
              type="text"
              name="name"
              value={values.name}
              onChange={handleChange}
              placeholder="Company Name"
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
          </div>
          <div className="flex flex-col gap-2">
            <label>Company Number</label>
            <input
              type="text"
              name="company_number"
              placeholder="Company Number"
              value={values.company_number}
              onChange={handleChange}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
          </div>
          <div className="flex flex-col gap-2 w-full">
            <label>Mobile Number*</label>
            <input
              type="text"
              name="mobile_number"
              placeholder="Mobile Number*"
              value={values.mobile_number}
              onChange={handleChange}
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
            />
            {errors.mobile_number && touched.mobile_number && (
              <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
                {errors.mobile_number || ""}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-2 w-full mt-4">
          <label>Number Properties*</label>
          <select
            name="no_of_properties"
            value={values.no_of_properties}
            onChange={handleChange}
            className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
          >
            <option value="">Please select...</option>
            <option>1</option>
            <option>2</option>
            <option>3</option>
          </select>
        </div>

        {errors.no_of_properties && touched.no_of_properties && (
          <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
            {errors.no_of_properties || ""}
          </p>
        )}

        <div className="mt-4 flex flex-col gap-2">
          <label> Property Management System?*</label>
          <select
            name="use_as"
            value={values.use_as}
            onChange={handleChange}
            className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
          >
            <option value="">Please select...</option>
            {options.map((option) => (
              <option key={option.id} value={option.name}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
        {errors.use_as && touched.use_as && (
          <p className="text-[#DC2626] text-[12px] h-[6px] pb-2">
            {errors.use_as || ""}
          </p>
        )}
        <div className="flex flex-col gap-2 mt-4 w-full">
          <label>How did you hear about us?*</label>
          <select
            name="hear_about_us"
            value={values.hear_about_us}
            onChange={handleChange}
            className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
          >
            <option value="">Please select...</option>
            {PMS_OPTIONS.map((option) => (
              <option key={option.id} value={option.name}>
                {option.name}
              </option>
            ))}
          </select>
        </div>

        {errors.hear_about_us && touched.hear_about_us && (
          <p className="text-[#DC2626] text-[12px] h-[6px] pb-2 mb-3">
            {errors.hear_about_us || ""}
          </p>
        )}

        <div className="flex justify-between mt-8 pb-10">
          <Link
            to={"/dashboard"}
            className="border-2 border-[#106A3A] text-black w-[80px] h-[50px] flex items-center justify-center rounded-md"
          >
            Skip
          </Link>
          <button
            onClick={handleSubmit}
            type="submit"
            className="bg-[#586989] text-white w-[80px] h-[50px] rounded-md"
          >
            {loading ? <ButtonLoader4 /> : <>Next</>}
          </button>
        </div>
      </div>
    </>
  );
};

export default Home;
